import { Injectable } from '@angular/core';
import { LoyaltyCodesForProductView } from '@src/api';
import { BaseStoreService } from '@src/app/modules/base';

@Injectable({
  providedIn: 'root',
})
export class LpMyProductCodesStoreService extends BaseStoreService<LoyaltyCodesForProductView[]> {}
